import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import { Select, SelectItemType } from '../ui/Select';
import { Id2 } from './id2';
import { WrapperS } from './styles';

interface HeaderProps {
  joinToRoom: (eventId: number, roomId: number) => void;
  leaveRoom: (eventId: number, roomId: number) => void;
}

export const Header: React.FC<HeaderProps> = ({ joinToRoom, leaveRoom }) => {
  const { Sockets } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  const { room, event } = Sockets;

  React.useEffect(() => {
    if (!room && event) {
      joinToRoom(event.rooms[0].event_id, event.rooms[0].absnum);
    }
  }, [dispatch, joinToRoom, room, event]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setRoom = (obj: SelectItemType) => {
    const roomId = Number(obj.value);

    event && room && leaveRoom(event.absnum, room.absnum);
    event && room && joinToRoom(event.absnum, roomId);
  };

  const data = event?.rooms?.map((room) => {
    return {
      id: room.absnum,
      title: `${room.name}`,
      value: `${room.absnum}`,
    };
  });

  return (
    <WrapperS>
      <div style={{ flex: 1 }}>
        <h3 style={{ margin: 0, textTransform: 'uppercase' }}>
          {event ? (event.rooms.length > 1 ? `${event.name}. ${room ? room.name : ''}` : `${event.name}`) : null}
        </h3>
      </div>
      <div style={{ marginRight: '30px', zIndex: 9 }}>
        {event && event.rooms.length > 1 && (
          <Select data={data || []} placeHolder={room ? room.name : 'Виберіть кімнату'} onChange={setRoom} selected={null} />
        )}
      </div>
      <Id2 />
    </WrapperS>
  );
};
